@if (questionForm) {
  <rt-interview-base-box
    [question]="questionForm.getRawValue()"
    [formGroup]="questionForm"
    [rtProtectedControl]="questionForm.controls.content"
    [rtProtectedControlEnabled]="hasProtectedControls()"
    [invalid]="
      questionForm.controls.content.invalid &&
      (questionForm.dirty || questionForm.touched) &&
      formSubmissionAttempt()
    "
    [errorMessage]="errorMessage"
  >
    @switch (questionForm.value.questionKind) {
      @case (QuestionKind.String) {
        <rt-input
          [placeholder]="placeholder() | translate"
          formControlName="content"
          variant="rounded"
        />
      }
      @case (QuestionKind.Text) {
        <rt-textarea
          [autoHeight]="true"
          formControlName="content"
          [placeholder]="placeholder() | translate"
        />
      }
    }
  </rt-interview-base-box>
}
